// extracted by mini-css-extract-plugin
export default {"root__followLabel":"SaveSellerControl-root__followLabel"};